"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSpecialityOutput = instanceOfSpecialityOutput;
exports.SpecialityOutputFromJSON = SpecialityOutputFromJSON;
exports.SpecialityOutputFromJSONTyped = SpecialityOutputFromJSONTyped;
exports.SpecialityOutputToJSON = SpecialityOutputToJSON;
var Entry_1 = require("./Entry");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the SpecialityOutput interface.
 */
function instanceOfSpecialityOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('metadata' in value) || value['metadata'] === undefined)
        return false;
    return true;
}
function SpecialityOutputFromJSON(json) {
    return SpecialityOutputFromJSONTyped(json, false);
}
function SpecialityOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Entry_1.EntryFromJSON)),
        'metadata': (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function SpecialityOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Entry_1.EntryToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
